// extracted by mini-css-extract-plugin
export var address = "footer-module--address--tEixc";
export var footerr = "footer-module--footerr--G7clB";
export var items = "footer-module--items--AkSEo";
export var start = "footer-module--start--wiyiT";